function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _templateObject;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { html } from "lit";
import { SelectedState } from "../selected-state.js";
import { property } from "lit/decorators.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;

var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;

  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }

  if (kind && result) __defProp(target, key, result);
  return result;
};

var OfferPaymentMixin = function OfferPaymentMixin(superClass) {
  var OfferPaymentElement = /*#__PURE__*/function (_superClass) {
    _inherits(OfferPaymentElement, _superClass);

    var _super = _createSuper(OfferPaymentElement);

    function OfferPaymentElement() {
      var _this;

      _classCallCheck(this, OfferPaymentElement);

      _this = _super.apply(this, arguments);
      _this.includePaymentElement = false;
      return _this;
    }
    /**
     * @ignore
     */


    _createClass(OfferPaymentElement, [{
      key: "renderPaymentElement",
      value: function renderPaymentElement() {
        if (this.includePaymentElement && this.selectedState === SelectedState.ACCEPTED) {
          return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["<payment-element .customerClientSecret=", " .clientId=", "></payment-element>"])), this.customerClientSecret, this.clientId);
        }
      }
    }, {
      key: "validate",
      value: function () {
        var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _a, currentErrors, isInsuranceValid, paymentElementValid, paymentElement, paymentValidationRes;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  currentErrors = [];
                  isInsuranceValid = this.selectedState != SelectedState.UNKNOWN;

                  if (!isInsuranceValid) {
                    currentErrors.push("selection_required");
                  }

                  paymentElementValid = true;
                  paymentElement = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("payment-element");

                  if (!paymentElement) {
                    _context.next = 11;
                    break;
                  }

                  _context.next = 8;
                  return paymentElement.validate();

                case 8:
                  paymentValidationRes = _context.sent;
                  currentErrors = [].concat(_toConsumableArray(currentErrors), _toConsumableArray(paymentValidationRes.errors));
                  paymentElementValid = paymentValidationRes.isValid;

                case 11:
                  this.errors = currentErrors;
                  return _context.abrupt("return", {
                    isValid: isInsuranceValid && paymentElementValid,
                    errors: currentErrors
                  });

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function validate() {
          return _validate.apply(this, arguments);
        }

        return validate;
      }()
    }, {
      key: "getPaymentToken",
      value: function () {
        var _getPaymentToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cardHolderName, billingZipCode, emailAddress) {
          var _a, paymentElement, paymentData;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!this.includePaymentElement) {
                    _context2.next = 8;
                    break;
                  }

                  paymentElement = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("payment-element");
                  paymentData = {
                    name: cardHolderName,
                    address_postal_code: billingZipCode
                  };

                  if (emailAddress) {
                    paymentData["email"] = emailAddress;
                  }

                  if (!paymentElement) {
                    _context2.next = 8;
                    break;
                  }

                  _context2.next = 7;
                  return paymentElement.tokenize(paymentData);

                case 7:
                  return _context2.abrupt("return", _context2.sent);

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function getPaymentToken(_x, _x2, _x3) {
          return _getPaymentToken.apply(this, arguments);
        }

        return getPaymentToken;
      }()
    }]);

    return OfferPaymentElement;
  }(superClass);

  __decorateClass([property({
    type: Boolean,
    attribute: "include-payment-element"
  })], OfferPaymentElement.prototype, "includePaymentElement", 2);

  return OfferPaymentElement;
};

export { OfferPaymentMixin };